import React, { useRef, useEffect } from 'react';

interface MobileMockupProps {
    backgroundColor: string;
    textColor: string;
    uiColor: string;
}

export const MobileMockup: React.FC<MobileMockupProps> = ({ backgroundColor, textColor, uiColor }) => {
    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas) {
            return;
        }
        const context = canvas.getContext('2d');

        if (!context) {
            return;
        }

        // Set the background
        context.fillStyle = backgroundColor;
        context.fillRect(0, 0, 400, 200);

        // Draw the inverted chevron
        context.strokeStyle = uiColor; // use strokeStyle instead of fillStyle
        context.lineWidth = 9;
        context.lineCap = "round";
        context.beginPath();
        context.moveTo(187, 25); // start from top left
        context.lineTo(207, 40); // line to middle
        context.lineTo(227, 25); // line to top right
        context.stroke(); // use stroke instead of fill

        // Draw the text
        context.fillStyle = textColor;
        context.font = '20px Verdana';
        context.textAlign = 'left';
        context.fillText('How do you savor the moment?', 20, 100);
    }, [backgroundColor, textColor, uiColor]);

    return <canvas ref={canvasRef} width={400} height={200} />;
};
